import React, { useState } from "react";

export default function BrainSchemaModal() {
  const [showFullscreen, setShowFullscreen] = useState(false);

  return (
    <>
      <div className="flex flex-col items-center gap-5 py-6 px-4">
        <div className="w-full max-w-4xl bg-black/40 border border-white/10 rounded-xl p-6 relative group">
          <img
            src="/assets/s2-p2-brain-schema-2.png"
            alt="Schéma cérébral annoté"
            className="w-full h-auto cursor-zoom-in transition-opacity hover:opacity-90"
            onClick={() => setShowFullscreen(true)}
          />
          <div className="absolute top-4 right-4 bg-black/80 border border-white/20 rounded-lg px-3 py-2 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
            <div className="flex items-center gap-2 text-xs text-slate-300">
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v6m3-3H7" />
              </svg>
              <span>Cliquer pour agrandir</span>
            </div>
          </div>
        </div>

        <div className="text-center max-w-2xl space-y-4">
          <div className="text-lg font-semibold text-white">
            Module d'Empathie Cognitive — Zones actives
          </div>

          <div className="grid grid-cols-3 gap-3 text-sm text-slate-300">
            <div className="p-3 bg-cyan-500/10 border border-cyan-500/30 rounded">
              <div className="text-cyan-400 font-mono font-bold mb-1">Zone A</div>
              <div className="text-xs text-slate-400">Cortex préfrontal médian</div>
              <div className="text-[10px] text-slate-500 mt-1">Théorie de l'esprit</div>
            </div>
            <div className="p-3 bg-fuchsia-500/10 border border-fuchsia-500/30 rounded">
              <div className="text-fuchsia-400 font-mono font-bold mb-1">Zone B</div>
              <div className="text-xs text-slate-400">Jonction temporo-pariétale</div>
              <div className="text-[10px] text-slate-500 mt-1">Perspective taking</div>
            </div>
            <div className="p-3 bg-amber-500/10 border border-amber-500/30 rounded">
              <div className="text-amber-400 font-mono font-bold mb-1">Zone C</div>
              <div className="text-xs text-slate-400">Cortex cingulaire antérieur</div>
              <div className="text-[10px] text-slate-500 mt-1">Régulation émotionnelle</div>
            </div>
            <div className="p-3 bg-emerald-500/10 border border-emerald-500/30 rounded">
              <div className="text-emerald-400 font-mono font-bold mb-1">Zone D</div>
              <div className="text-xs text-slate-400">Insula antérieure</div>
              <div className="text-[10px] text-slate-500 mt-1">Empathie émotionnelle</div>
            </div>
            <div className="p-3 bg-rose-500/10 border border-rose-500/30 rounded">
              <div className="text-rose-400 font-mono font-bold mb-1">Zone E</div>
              <div className="text-xs text-slate-400">Cortex moteur primaire</div>
              <div className="text-[10px] text-slate-500 mt-1">Contrôle moteur</div>
            </div>
            <div className="p-3 bg-violet-500/10 border border-violet-500/30 rounded">
              <div className="text-violet-400 font-mono font-bold mb-1">Zone F</div>
              <div className="text-xs text-slate-400">Cortex visuel primaire</div>
              <div className="text-[10px] text-slate-500 mt-1">Traitement visuel</div>
            </div>
          </div>

          <div className="mt-6 p-4 bg-slate-900/70 border border-cyan-500/40 rounded text-xs">
            <div className="flex items-center gap-2 mb-3">
              <div className="w-2 h-2 bg-cyan-400 rounded-full animate-pulse"></div>
              <span className="font-semibold text-cyan-300 uppercase tracking-wider">Note de calibration</span>
            </div>
            <p className="text-slate-300 leading-relaxed">
              La séquence d'activation optimale doit suivre le{" "}
              <span className="text-cyan-400 font-semibold">parcours neural</span>.
              <br />
              Observer attentivement les connexions entre les zones pour déterminer l'ordre de calibration.
            </p>
            <div className="mt-3 pt-3 border-t border-slate-700/50 text-[10px] text-slate-500 font-mono">
              Protocole validé — Dr. M. Chen — 2024-11-03 — LAB-EC-v2.4
            </div>
          </div>
        </div>
      </div>

      {/* Fullscreen — overlay scrollable */}
      {showFullscreen && (
        <div
          className="fixed inset-0 z-[9999] bg-black/95 backdrop-blur-sm overflow-auto"
          onClick={() => setShowFullscreen(false)}
        >
          <div
            className="min-h-full flex flex-col items-center justify-start py-16 px-4 gap-4"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Bouton fermer */}
            <button
              onClick={() => setShowFullscreen(false)}
              className="self-end flex items-center gap-2 px-4 py-2 rounded-lg bg-slate-800/80 border border-slate-600 text-slate-300 hover:text-white hover:bg-slate-700 transition-all text-sm font-medium"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
              Fermer
            </button>

            {/* Image — taille naturelle, scroll si nécessaire */}
            <img
              src="/assets/s2-p2-brain-schema-2.png"
              alt="Schéma cérébral annoté (plein écran)"
              className="max-w-full rounded-lg shadow-2xl cursor-zoom-out"
              style={{ width: "min(100%, 1400px)" }}
              onClick={() => setShowFullscreen(false)}
            />

       
          </div>
        </div>
      )}
    </>
  );
}